'use strict';

import { cn_facing_layer } from './cn_facing_layer';
import { cn_element_type } from './cn_element_type';
import { cn_element_type_visitor } from '../utils/visitors/cn_element_type_visitor';
import { cn_building } from './cn_building';
import { cn_facing_family } from './cn_facing_family';
import { cn_image_dir } from '../utils/image_dir';
import { generate_pattern_for_facing } from '../utils/cn_svg_patterns';

export const DEFAULT_FACING_LIST = [
    { code: 'paint', label: 'Peinture', family:'Mur intérieur'},
    { code: 'plaster', label: 'Enduit', family:'Mur intérieur'},
    { code: 'wallpaper', label: 'Papier peint' , family:'Mur intérieur'},
    { code: 'fibreglass', label: 'Toile de verre' , family:'Mur intérieur'},
    { code: 'fabric', label: 'Tissus mural' , family:'Mur intérieur'},
    { code: 'wall_tiles', label: 'Crédence' , family:'Mur intérieur'},
    { code: 'wood_wall', label: 'Lambris' , family:'Mur intérieur'},
    
    { code: 'brick', label: 'Brique', family:'Mur extérieur' },
    { code: 'stone', label: 'Pierre' , family:'Mur extérieur'},
    { code: 'wood_facade', label: 'Bardage bois' , family:'Mur extérieur'},
    { code: 'pvc_facade', label: 'Bardage PVC' , family:'Mur extérieur'},
    { code: 'alu_facade', label: 'Bardage alu' , family:'Mur extérieur'},
    { code: 'cladding', label: 'Plaquettes parement' , family:'Mur extérieur'},

    { code: 'carpet', label: 'Moquette' , family:'Sol intérieur'},
    { code: 'polished_concrete', label: 'Béton ciré' , family:'Sol intérieur'},
    { code: 'tiles', label: 'Carrelage' , family:'Sol intérieur'},
    { code: 'wood', label: 'Parquet massif' , family:'Sol intérieur'},
    { code: 'wood_tiles', label: 'Parquet flottant' , family:'Sol intérieur'},
    { code: 'vinyl', label: 'Lino' , family:'Sol intérieur'},

    { code: 'asphalt', label: 'Asphalte', family:'Sol extérieur'},
    { code: 'concrete', label: 'Béton' , family:'Sol extérieur'},
    { code: 'gravel', label: 'Gravier' , family:'Sol extérieur'},
    { code: 'lawn', label: 'Pelouse' , family:'Sol extérieur'},
    { code: 'marble', label: 'Dallage' , family:'Sol extérieur'},
    { code: 'pavement', label: 'Pavement' , family:'Sol extérieur'}
];

export const DEFAULT_FACING_FAMILY_LIST = [
    'Mur intérieur',
    'Mur extérieur',
    'Sol intérieur',
    'Sol extérieur'
];

//***********************************************************************************
//***********************************************************************************
//******     CN-Map    **************************************************************
//******     Copyright(C) 2019-2020 EnerBIM                        ******************
//***********************************************************************************
//***********************************************************************************


export class cn_facing_group {
    constructor(label, code, side, support, roles) {
        this.label = label;
        this.code = code;
        this.side = side;
        this.support = support;
        this.roles = roles;
    }

    static serialize(facings, facing_groups) {
        let json = [{}, {}];
        facing_groups.forEach(gr => {
            gr.roles.forEach(role => {
                let facing = facings[gr.side][role.code];
                if (typeof (facing) != 'undefined')
                    json[gr.side][role.code] = (facing) ? facing.ID : null;
            });
        });
        return json;
    }

    static unserialize_facings(facings, json, building) {
        if (typeof (json.facings) != "object") return;
        for (var i = 0; i < 2; i++) {
            if (typeof (json.facings[i]) != "object") continue;
            for (var key in json.facings[i]) {
                if (typeof (key) != 'string') continue;
                let value = json.facings[i][key];
                if (typeof (value) == 'string')
                    facings[i][key] = building.facing_types.find(fa => fa.ID === value) || null;
                else
                    facings[i][key] = null;
            }
        }

        //*** Backward compatibility */
        if (typeof (json.similar_facings) == 'boolean') {
            if (json.similar_facings) {
                for (var side = 0; side < 2; side++) {
                    let default_facing = building.facing_types.find(fa => fa.ID == json.facings[side][0]) || null;
                    for (var key in facings[side])
                        facings[side][key] = default_facing;
                }
            }
            else {
                let roles = ["", "opening", "sill", "transom", "closing"];
                for (var side = 0; side < 2; side++) {
                    for (var n = 1; n < json.facings[side].length; n++) {
                        if (n > 4) break;
                        let default_facing = building.facing_types.find(fa => fa.ID == json.facings[side][n]) || null;
                        facings[side][roles[n]] = default_facing;
                    }
                }
            }
        }
    }
    
    static unserialize_substrates(facings, json, all_substrates) {
        if (typeof (json) != "object") return;
        for (var i = 0; i < 2; i++) {
            if (typeof (json[i]) != "object") continue;
            for (var key in json[i]) {
                if (typeof (key) != 'string') continue;
                let value = json[i][key];
                if (typeof (value) == 'string')
                    facings[i][key] = all_substrates.find(fa => fa.ID === value) || null;
                else
                    facings[i][key] = null;
            }
        }
    }

    static clone(facings) {
        return facings.map(fl => {
            let cl = {};
            for (var key in fl)
                cl[key] = fl[key];
            return cl;
        });
    }
}

//***********************************************************************************
/**
 * @class cn_facing
 * Class to modelize the facing of a wall, slab, etc.
 */
export class cn_facing extends cn_element_type {
    //***********************************************************************************
    /**
     * Constructor
     * @param parent
     */
    constructor(parent) {
        super(parent);
        this.class_name = 'cn_facing';
        this.name = '';
        this.category = '';
        this.texture = '';
        this.color = '';
        this.description = '';
        this.facing_layers = [];
        this.family = "";
    }

    //*******************************************************
    /**
     * clone this
     * @returns {cn_facing}
     */
    clone() {
        const cloned = cn_facing.unserialize(this.serialize(), this.parent);
        cloned.ID = cn_element_type.generate_ID(); // generates another ID
        return cloned;
    }

    //***********************************************************************************
    /**
     * TODO : derivate this in order to create default families
     * @returns {string}
     */
    get_family() {
        if (this.family != "")
            return this.family;
        let cst = DEFAULT_FACING_LIST.find(f => f.code == this.texture);
        if (cst) return cst.family;
        return "";
    }

    //***********************************************************************************
    /**
     * TODO : derivate this in order to return default families
     * @returns {string[]}
     */
    get_default_families() {
        return DEFAULT_FACING_FAMILY_LIST;
    }

    //***********************************************************************************
    /**
     * serialize
     * @returns {object}
     */
    serialize() {
        const json = this.serialize_element();
        json.class_name = 'cn_facing';
        json.name = this.name;
        json.description = this.description;
        json.texture = this.texture;
        json.color = this.color;
        json.category = this.category;
        json.facing_layers = this.facing_layers.map(layer => layer.serialize());
        json.family = this.family;
        return json;
    }

    //***********************************************************************************
    /**
     * unserialize
     * @param {object} json
     * @param {cn_building} building
     * @returns {cn_facing | null}
     */
    static unserialize(json, building) {
        const result = new cn_facing(building);
        result.unserialize_element(json);
        result.name = json.name;
        result.description = json.description;
        result.category = json.category;
        result.texture = json.texture;
        result.facing_layers = json.facing_layers.map(layer => cn_facing_layer.unserialize(layer));
        result.color = json.color;
        if (typeof(json.family) == 'string')
            result.family = json.family;
        return result;
    }

    static default_types(building) {
        let default_types = [];

        DEFAULT_FACING_LIST.forEach(default_facing => {
            if (default_types.find(t => t.texture == default_facing.code)) return;
            let facing = new cn_facing(building);
            facing.texture = default_facing.code;
            facing.name = default_facing.label;
            default_types.push(facing);
        });

        return default_types;
    }

    //***********************************************************************************
    //**** return label
    //***********************************************************************************
    get_label() {
        return this.name;
    }

    /**
     * Returns an array of objects describing the type.
     * @returns {{label: string, value?: any, decimals?: number, unit?: string}[]}
     */
    get_description() {
        const description = [];

        if (this.description) {
            description.push({ label: 'Description', value: this.description });
        }

        const layers = { label: 'Matériaux' };
        layers.value = [];

        for (let i in this.facing_layers) {
            layers.value.push(this.facing_layers[i].get_label());
        }
        if (layers.value.length) {
            description.push(layers);
        }

        return description;
    }

    /**
     * Accept element visitor
     *
     * @param {cn_element_type_visitor} element_type_visitor
     */
    accept_visitor(element_type_visitor) {
        element_type_visitor.visit_facing_type(this);
    }

    //***********************************************************************************
    /**
     * draw svg icon
     * @param {number} width
     * @param {number} height
     * @returns {string}
     */
    draw_svg_icon(width, height) {
        let html = "";
        const texture_pattern_and_style = generate_pattern_for_facing(this.texture, this.color,
            0, 0, width, height);
        html += texture_pattern_and_style.pattern;
        this.add_attr = texture_pattern_and_style.style;
        html += `<rect ${texture_pattern_and_style.style} x="0" y="0" width="${width}" height="${height}"/>`;
        return html;

        return `<image xlink:href="${cn_image_dir()}texture_${this.texture}.jpg" x="0" y="0" width="${width}" height="${height}" preserveAspectRatio="xMidYMid slice" />`;
    }

    get_url() {
        return `${cn_image_dir()}texture_${this.texture}.jpg`;
    }

}

